import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";
import { FaAward } from "react-icons/fa6";
import TrainingCertificates from "./index";
import { MODULE_CERTIFICATIONS } from "variables/constants";
// import ViewTrainingOverview from "./view";
// import EditTrainingOverview from "./edit";

const trainingCertificationRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Certifications",
		basePath: "training-certifications",
		mainComponent: <TrainingCertificates />,
	    layout: "/console",	   
	    icon: <FaAward className="icon-item" />,
	    subTitle:"Training Certifications",
	    // viewComponent: <ViewTrainingOverview />,
	    // createComponent: <EditTrainingOverview />,
	    // editComponent: <EditTrainingOverview />,
		level:5,
		moduleId: MODULE_CERTIFICATIONS,
	})
]

export default trainingCertificationRoutes;